import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import info from "assets/img/info.png";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    position: "relative",
    borderRadius: 8,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
    outline: "none",
    minWidth: "auto",
    maxWidth: 477,
    textAlign: "center",
  },
  img: {
    scale: 0.7,
    marginTop: "1rem",
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 24,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textAlign: "center",
  },
  cancelButton: {
    backgroundColor: "#fff",
    border: "2px solid #a1c330",
    width: 138,
    height: 35,
    color: "#a1c330",
  },
  acceptButton: {
    backgroundColor: "#a1c330",
    width: 138,
    color: "#fff",
    "&:hover": {
      backgroundColor: "#a1c330",
      opacity: "0.8",
    },
  },
}));

const ConfirmationModal = ({
  open,
  onClose,
  onAccept,
  bodyContent,
  title = "",
}) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      disableBackdropClick={true}
    >
      <div className={classes.paper}>
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon style={{ color: "black" }} />
        </IconButton>
        <Typography variant="h6">{title}</Typography>
        <img className={classes.img} src={info} alt="icon" />
        <Typography style={{ fontSize: 18, fontWeight: "bold" }}>
          ¿Esta seguro que desea realizar la acción?
        </Typography>

        <Typography style={{ maxWidth: 450, fontSize: 14, padding: 16 }}>
          {bodyContent}
        </Typography>
        <div className={classes.buttonContainer}>
          <Button className={classes.cancelButton} onClick={onClose}>
            Cancelar
          </Button>
          <Button className={classes.acceptButton} onClick={onAccept}>
            Aceptar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  bodyContent: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default ConfirmationModal;
